import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import VueLib from 'vue';

/* eslint-enable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
var delayedCalls = [];
var SentryMock = {};
var sentryReadyResolve;
var loadInitiated = false;
var loadCompleted = false;
var delayedGlobalErrors = [];
var delayedUnhandledRejections = [];
/** @param {ErrorEvent} event */
var delayGlobalError = function delayGlobalError(event) {
  delayedGlobalErrors.push([event.message, event.filename, event.lineno, event.colno, event.error]);
};
var delayUnhandledRejection = function delayUnhandledRejection(event) {
  delayedUnhandledRejections.push('reason' in event ? event.reason : 'detail' in event && 'reason' in event.detail ? event.detail.reason : event);
};
var vueErrorHandler = VueLib.config.errorHandler;
VueLib.config.errorHandler = function (error, vm, info) {
  if (!loadCompleted) {
    if (vm) {
      vm.$sentry.captureException(error);
    }
    if (VueLib.util) {
      VueLib.util.warn("Error in ".concat(info, ": \"").concat(error.toString(), "\""), vm);
    }
    console.error(error); // eslint-disable-line no-console
  }

  if (vueErrorHandler) {
    return vueErrorHandler(error, vm, info);
  }
};
export default function SentryPlugin(ctx, inject) {
  /* eslint-disable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  var apiMethods = ["addGlobalEventProcessor", "addBreadcrumb", "captureException", "captureEvent", "captureMessage", "configureScope", "getHubFromCarrier", "getCurrentHub", "Hub", "makeMain", "Scope", "Session", "startTransaction", "setContext", "setExtra", "setExtras", "setTag", "setTags", "setUser", "withScope", "BrowserClient", "injectReportDialog", "eventFromException", "eventFromMessage", "forceLoad", "init", "lastEventId", "onLoad", "showReportDialog", "flush", "close", "wrap"];
  apiMethods.forEach(function (key) {
    SentryMock[key] = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return delayedCalls.push([key, args]);
    };
  });
  window.addEventListener('error', delayGlobalError);
  window.addEventListener('unhandledrejection', delayUnhandledRejection);
  inject('sentry', SentryMock);
  ctx.$sentry = SentryMock;
  var loadSentryHook = function loadSentryHook() {
    return attemptLoadSentry(ctx, inject);
  };
  window.onNuxtReady(loadSentryHook);
  var sentryReadyPromise = new Promise(function (resolve) {
    sentryReadyResolve = resolve;
  });
  var sentryReady = function sentryReady() {
    return sentryReadyPromise;
  };
  inject('sentryReady', sentryReady);
  ctx.$sentryReady = sentryReady;
}
function attemptLoadSentry(_x, _x2) {
  return _attemptLoadSentry.apply(this, arguments);
}
function _attemptLoadSentry() {
  _attemptLoadSentry = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ctx, inject) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!loadInitiated) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          loadInitiated = true;
          if (window.$nuxt) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return");
        case 5:
          _context.next = 7;
          return loadSentry(ctx, inject);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _attemptLoadSentry.apply(this, arguments);
}
function loadSentry(_x3, _x4) {
  return _loadSentry.apply(this, arguments);
} // Custom inject function that is able to overwrite previously injected values,
// which original inject doesn't allow to do.
// This method is adapted from the inject method in nuxt/vue-app/template/index.js
function _loadSentry() {
  _loadSentry = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ctx, inject) {
    var Sentry, _yield$import, Dedupe, ExtraErrorData, RewriteFrames, Vue, config, runtimeConfigKey, _yield$import2, merge, _iterator, _step, errorArgs, _iterator2, _step2, reason;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!loadCompleted) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return");
        case 2:
          _context2.next = 4;
          return import( /* webpackChunkName: 'sentry' */'@sentry/browser');
        case 4:
          Sentry = _context2.sent;
          _context2.next = 7;
          return import( /* webpackChunkName: 'sentry' */'@sentry/integrations');
        case 7:
          _yield$import = _context2.sent;
          Dedupe = _yield$import.Dedupe;
          ExtraErrorData = _yield$import.ExtraErrorData;
          RewriteFrames = _yield$import.RewriteFrames;
          Vue = _yield$import.Vue;
          /* eslint-disable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
          config = {
            "dsn": "https://9991bff7395240a593b8b973747e463a@o986411.ingest.sentry.io/5952605",
            "environment": "prod",
            "attachStacktrace": true,
            "autoSessionTracking": true,
            "release": "5227e2e8a468b4c335f65404f315009ebb5b730d",
            "tracesSampleRate": 1
          };
          runtimeConfigKey = "sentry";
          if (!(ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey])) {
            _context2.next = 20;
            break;
          }
          _context2.next = 17;
          return import( /* webpackChunkName: 'sentry' */'lodash.mergewith');
        case 17:
          _yield$import2 = _context2.sent;
          merge = _yield$import2.default;
          merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig);
        case 20:
          config.integrations = [new Dedupe(), new ExtraErrorData(), new RewriteFrames(), new Vue(_objectSpread({
            Vue: VueLib
          }, {
            "attachProps": true,
            "logErrors": false
          }))];
          /* eslint-enable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
          Sentry.init(config);
          loadCompleted = true;
          window.removeEventListener('error', delayGlobalError);
          window.removeEventListener('unhandledrejection', delayUnhandledRejection);
          if (delayedGlobalErrors.length) {
            if (window.onerror) {
              console.info('Reposting global errors after Sentry has loaded'); // eslint-disable-line no-console
              _iterator = _createForOfIteratorHelper(delayedGlobalErrors);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  errorArgs = _step.value;
                  window.onerror.apply(window, errorArgs);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }
            delayedGlobalErrors = [];
          }
          if (delayedUnhandledRejections.length) {
            if (window.onunhandledrejection) {
              console.info('Reposting unhandled promise rejection errors after Sentry has loaded'); // eslint-disable-line no-console
              _iterator2 = _createForOfIteratorHelper(delayedUnhandledRejections);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  reason = _step2.value;
                  window.onunhandledrejection(reason);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
            delayedUnhandledRejections = [];
          }
          delayedCalls.forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
              methodName = _ref2[0],
              args = _ref2[1];
            return Sentry[methodName].apply(Sentry, args);
          });
          forceInject(ctx, inject, 'sentry', Sentry);
          sentryReadyResolve(Sentry);

          // help gc

          // Dont unset delayedCalls & SentryMock during
          // development, this will cause HMR issues

          delayedCalls = undefined;
          SentryMock = undefined;
          sentryReadyResolve = undefined;
        case 33:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _loadSentry.apply(this, arguments);
}
function forceInject(ctx, inject, key, value) {
  inject(key, value);
  var injectKey = '$' + key;
  ctx[injectKey] = value;
  window.$nuxt.$options[injectKey] = value;
}